(function ($) {
    $(document).ready(function () {
        $('.tcu_page .tcu_submit').click(function(e){
            e.preventDefault;
            if(!$(this).hasClass('disabled')){
                if(luCalculatorValidForm($('.tcu_page form.tcu_form'))){
                    $('.empty_fields_error').hide();
                    var formData = $('.tcu_page form.tcu_form').serializeArray();
                    var url = '/wp-admin/admin-ajax.php';
                    if(window.location.href.indexOf('testonline') != -1){
                        url = 'wp-admin/admin-ajax.php';
                    }
                    $.ajax({
                        url: url, // AJAX handler
                        type: 'POST',
                        data:{
                            action:'get_lu_calculator_response',
                            formData: formData
                        },
                        
                        success: function (res) {
                            //console.log(res)
                            res = JSON.parse(res);
                            if(res.success == 'true' ){
                                $('.tcu_before_calculate').fadeOut();
                                $('.tcu_after_calculate').fadeIn();
                                $('.tcu_page .tcu_after_calculate .tcu_response .tcu_selected_distance').html(res.result.distance);
                                $('.tcu_page .tcu_after_calculate .tcu_response .tcu_selected_year').html(res.result.years);
                                $('.tcu_page .tcu_after_calculate .tcu_response .tcu_selected_model_text').html(res.result.model);
                                $('.tcu_after_calculate .tcu_response_header .tcu_full_time_savings .tcu_total').html(res.result.full_time_total.replace('-',''));
                                //$('.tcu_after_calculate .tcu_response_content .tcu_response_content_image img').attr('src',res.result.image_link);
                                $('.tcu_after_calculate .tcu_response_content .tcu_monthly_savings .tcu_total').html(res.result.monthly_total.replace('-',''));
                                $('.tcu_after_calculate .tcu_response_content .tcu_yearly_savings .tcu_total').html(res.result.yearly_total.replace('-',''));
                                $('.tcu_before_calculate').hide();
                                $('.tcu_after_calculate').show();
                                $('.tcu_after_calculate .tcu_back_link').focus();
                                dataLayer.push({
                                    'step':'results-calc',
                                    'funnelName':'Calculator',
                                    'model':$('.tcu_page form.tcu_form select.tcu_select.tcu_brands').val(),
                                    'subModel':$('.tcu_page form.tcu_form select.tcu_select.tcu_models').val(),
                                    'event':'changeStep'
                                });
                                //console.log(dataLayer);
                            } else{
                                $('.tcu_before_calculate .error_result').show();
                            }
                        }
                });  
            }
            else{
                $('.empty_fields_error').show();
            }
        }
        return false;
    });
    function luCalculatorValidForm(form){
        var valid = true;
        if(form.find('select.tcu_brands').val() == '*בחר מותג' || form.find('select.tcu_brands').val() == '* בחר מותג'){
            form.find('.tcu_brands_error').show();
            valid = false;
        }
        else{
            form.find('.tcu_brands_error').hide();  
        }
        if(form.find('select.tcu_models').val() == '*בחר דגם' || form.find('select.tcu_models').val() == '* בחר דגם' || form.find('select.tcu_models').val() == null){
            form.find('.tcu_models_error').show();
            valid = false;
        }
        else{
            form.find('.tcu_models_error').hide();  
        }
        if(!form.find('#tcu_agree').is(':checked')){
            var width = $('.tcu_agree_label .checkbox-holder').width() + $('.tcu_agree_label .checkbox-text').width() + $('.tcu_agree_label a').width();
            form.find('.tcu_agree_error').width(width + 10).show();
            valid = false;
        }
        else{
            form.find('.tcu_agree_error').hide();  
        }
        
        return valid;
    }
});
})(jQuery);


// WEBPACK FOOTER //
// assets/scripts/client/submitForm.js